import { Component, OnInit ,ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../../services/admin';

import Swal from 'sweetalert2'
import { Popup } from 'ng2-opd-popup';
declare var toastr: any;
declare var mdtoast: any;
declare var $;
var success_message = mdtoast("Opération effectué avec succès. En attante de validation par le Médecin", { duration: 5000, init: true, type: mdtoast.SUCCESS });

@Component({
  selector: 'app-procedure-consultation',
  templateUrl: './procedure-consultation.component.html',
  styleUrls: ['./procedure-consultation.component.scss']
})
export class ProcedureConsultationComponent implements OnInit {
  pdfSrc: string = "assets/file/affiche/gyneco.pdf";
  pdfSrc2: string = "assets/file/procedure/gyneco.pdf";
  id: any;
  mode_dr: any = 11;
  mode_dr_tsz:number = 1;
  nbr_anattente_actuel: number=6;
  nbr_recut_actuel:number = 12;
  listeatt_by_dr: any;
  date_clic: Date;
  @ViewChild('popupProcedure') popupProcedure: Popup;
  @ViewChild('popupDossierUtil') popupDossierUtil: Popup;
  agent_iscrit: any;
  listeatt_by_dr_norolala: any;
  listeatt_by_dr_roland: any;
  listeatt_by_dr_onja: any;
  listeatt_by_dr_rina: any;
  listeatt_by_dr_vony: any;
  listeatt_by_dr_imisa: any;
  listeatt_by_dr_tiana: any;
  listeatt_by_dr_lanto: any;
  listeatt_by_dr_laingo: any;
  listeatt_by_dr_koloina: any;
  listeatt_by_dr_fanja: any;
  listeatt_by_dr_Nivo: any;
  listeatt_by_dr_andry: any;
  listeatt_by_dr_mamy: any;
  listeatt_by_dr_rija: any;
  listeatt_by_dr_violety: any;
  listeatt_by_dr_manohy: any;
  listeatt_by_dr_ifano: any;
  listeatt_by_dr_hery: any;
  listeatt_by_dr_thierry: any;
  listeatt_by_dr_hary: any;

  constructor(public activatedRoute: ActivatedRoute, private router: Router,public adminService: AdminService) {
    this.id = activatedRoute.snapshot.params['id'];
    if (this.id == 1) {
      this.mode_dr = 1;
      this.getListeAttenteDrANS();
    }else if (this.id == 2) {
      this.mode_dr = 2;
         this.getListeAttenteDrTSZ()
    } else if (this.id == 3){
      this.mode_dr = 3;
       this.getListeAttenteDrAnt();
    }

  }

  

  ngOnInit() {
    this.agent_iscrit = this.adminService.getUserIscrit();
    this.date_clic= new Date();
   // this.getListeAttenteParMed();*
   
  

  }

 
 
  pagination(inte:number){
    if(inte==2){
      this.mode_dr_tsz=2;
      this.getListeAttenteDrTSZ2()
    }else{
      this.mode_dr_tsz=1;
      this.getListeAttenteDrTSZ()
    }
   
  }

 
  getInfoMedecinbyMatricule(){
    this.adminService.getInfoMedByIM(this.id)
    .subscribe(data => {
      this.listeatt_by_dr = data;
      this.date_clic= new Date();
    }, err => {
      console.log(err);
    })
  }


  //Med ANT
  getListeAttenteDrAnt(){
    this.adminService.getListeAttenteParMedParIM(372425)
    .subscribe(data => {
      console.log("this.listeatt_by_dr_Imisa")
      this.listeatt_by_dr_imisa=data;
    }, err => {
      console.log(err);
    });
    this.getListeAttenteDrVony();
    this.getListeAttenteDrRina();
    this.getListeAttenteDrOnja();
  }

  getListeAttenteDrVony(){
    this.adminService.getListeAttenteParMedParIM(311183)
    .subscribe(data => {
      this.listeatt_by_dr_vony=data;
    }, err => {
      console.log(err);
    })
  }


  getListeAttenteDrRina(){
    this.adminService.getListeAttenteParMedParIM(405578)
    .subscribe(data => {
      this.listeatt_by_dr_rina=data;
    }, err => {
      console.log(err);
    })
  }

  getListeAttenteDrOnja(){
    this.adminService.getListeAttenteParMedParIM(375250)
    .subscribe(data => {
      this.listeatt_by_dr_onja=data;
    }, err => {
      console.log(err);
    })
  }


  //Med TSZ

  getListeAttenteDrTSZ(){
    this.adminService.getListeAttenteParMedParIM(300382)
    .subscribe(data => {
      console.log("this.listeatt_by_dr_Tiana")
      this.listeatt_by_dr_tiana=data;
    }, err => {
      console.log(err);
    });
     this.getListeAttenteDrLanto();
     this.getListeAttenteDrLaingo();
     this.getListeAttenteDrKoloina();     
     this.getListeAttenteDrFanja();
     this.getListeAttenteDrNivo();
  }


  getListeAttenteDrLanto(){
    this.adminService.getListeAttenteParMedParIM(300387)
    .subscribe(data => {
      this.listeatt_by_dr_lanto=data;
    }, err => {
      console.log(err);
    })
  }

  getListeAttenteDrLaingo(){
    this.adminService.getListeAttenteParMedParIM(405900)
    .subscribe(data => {
      this.listeatt_by_dr_laingo=data;
    }, err => {
      console.log(err);
    })
  }


  getListeAttenteDrKoloina(){
    this.adminService.getListeAttenteParMedParIM(300386)
    .subscribe(data => {
      this.listeatt_by_dr_koloina=data;
    }, err => {
      console.log(err);
    })
  }


  getListeAttenteDrFanja(){
    this.adminService.getListeAttenteParMedParIM(375250)
    .subscribe(data => {
      this.listeatt_by_dr_fanja=data;
    }, err => {
      console.log(err);
    })
  }

  getListeAttenteDrNivo(){
    this.adminService.getListeAttenteParMedParIM(300385)
    .subscribe(data => {
      this.listeatt_by_dr_Nivo=data;
    }, err => {
      console.log(err);
    })
  }


  //load on clic button

  getListeAttenteDrTSZ2(){
    this.getListeAttenteDrRija();
  }


  getListeAttenteDrRija(){
    this.adminService.getListeAttenteParMedParIM(344454)
    .subscribe(data => {
      this.listeatt_by_dr_rija=data;
    }, err => {
      console.log(err);
    })
    this.getListeAttenteDrMamy();
    this.getListeAttenteDrAndry();
     this.getListeAttenteDrViolety();
    this.getListeAttenteDrManohy();
    this.getListeAttenteDrIfano();
    this.getListeAttenteDrHery();
    this.getListeAttenteDrThierry();
    this.getListeAttenteDrHary();
  }

  getListeAttenteDrMamy(){
    this.adminService.getListeAttenteParMedParIM(303246)
    .subscribe(data => {
      this.listeatt_by_dr_mamy=data;
    }, err => {
      console.log(err);
    })
  }


  getListeAttenteDrAndry(){
    this.adminService.getListeAttenteParMedParIM(275152)
    .subscribe(data => {
      this.listeatt_by_dr_andry=data;
    }, err => {
      console.log(err);
    })
  }


  getListeAttenteDrViolety(){
    this.adminService.getListeAttenteParMedParIM(282327)
    .subscribe(data => {
      this.listeatt_by_dr_violety=data;
    }, err => {
      console.log(err);
    })
  }

  getListeAttenteDrManohy(){
    this.adminService.getListeAttenteParMedParIM(329214)
    .subscribe(data => {
      this.listeatt_by_dr_manohy=data;
    }, err => {
      console.log(err);
    })
  }


  getListeAttenteDrIfano(){
    this.adminService.getListeAttenteParMedParIM(250684)
    .subscribe(data => {
      this.listeatt_by_dr_ifano=data;
    }, err => {
      console.log(err);
    })
  }



  getListeAttenteDrHery(){
    this.adminService.getListeAttenteParMedParIM(300381)
    .subscribe(data => {
      this.listeatt_by_dr_hery=data;
    }, err => {
      console.log(err);
    })
  }

  getListeAttenteDrThierry(){
    this.adminService.getListeAttenteParMedParIM(332157)
    .subscribe(data => {
      this.listeatt_by_dr_thierry=data;
    }, err => {
      console.log(err);
    })
  }


  getListeAttenteDrHary(){
    this.adminService.getListeAttenteParMedParIM(330027)
    .subscribe(data => {
      this.listeatt_by_dr_hary=data;
    }, err => {
      console.log(err);
    })
  }






  //Med Anosy
  getListeAttenteDrANS(){
    this.adminService.getListeAttenteParMedParIM(301981)
    .subscribe(data => {
      console.log("this.listeatt_by_dr_norolala")
      this.listeatt_by_dr_norolala=data;
      console.log(this.listeatt_by_dr_norolala)
    }, err => {
      console.log(err);
    });
    this.getListeAttenteDrRoland()
  }


  getListeAttenteDrRoland(){
    this.adminService.getListeAttenteParMedParIM(271140)
    .subscribe(data => {
      this.listeatt_by_dr_roland=data;
    }, err => {
      console.log(err);
    })
  }



  Rendez_vous(id:any,id2:any){   
    /// this.router.navigate(['nucleoicons']);
    if(this.agent_iscrit=="OK"){
      this.router.navigate(['agenda/'+id+"/"+id2]);
    }else{
      Swal.fire({
        title: 'Agent non inscrit',
        icon: 'info',
        text: '..........Text intro mes historiques...........',
        // icone: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Dossiers à fournir',
        cancelButtonText: 'Fermer'
      }).then((result) => {
        if (result.value) {
         this.open2();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
        }
      });
    }
     
   }
  



  open() {
    this.popupProcedure.options = { 
   
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 1.5,
      header: "Procédure de consltation",
      widthProsentage: 80,
      animation: "fadeInRight",
      confirmBtnContent: "Autre Site",
      cancleBtnContent: "Fermer",
    }

    this.popupProcedure.show(this.popupProcedure.options);
  }

  return(){   
     this.router.navigate(['cons-medical']);
   }

  fermerProcedure(){
this.return();
  }


  open2() {
    this.popupDossierUtil.options = { 
   
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 1.5,
      header: "Dossiers à fournir ...",
      widthProsentage: 80,
      animation: "fadeInLeft",
      confirmBtnContent: "Retour",
      cancleBtnContent: "Fermer",
    }

    this.popupDossierUtil.show(this.popupDossierUtil.options);
  }

  fermerDossier(){
    this.popupDossierUtil.hide();
  }



}
